import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import {
    AttentionBox,
    FieldRow,
    PageIntro,
    Panel,
    SummaryItem,
    SummaryList,
    TwoColumnLayout
} from '../../components/ui';
import { fetchFlask } from '../../utils/fetchFlask';

const InformarDebitos = () => {
    const [ccs, setCCs] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitInformarDebitos (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            ccs
        });
        try {
            const response = await fetchFlask('informarDebitos', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setCCs('');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const ccsList = ccs
        .split(/[\s,;]+/)
        .map((cc) => cc.trim())
        .filter(Boolean);
    const completedFields = [ccsList.length > 0].filter(Boolean).length;

    const summary = (
        <Panel eyebrow='Resumo' icon={FactCheckRoundedIcon} title='Revisão do lote'>
            <SummaryList>
                <SummaryItem
                    label='Contas contrato'
                    empty={ccsList.length === 0}
                    value={ccsList.length === 0 ? 'Não informadas' : `${ccsList.length} identificada${ccsList.length === 1 ? '' : 's'}`}
                />
                <SummaryItem label='Canal' value='WhatsApp' />
                <SummaryItem label='Referência' value='Débitos Neoenergia' />
            </SummaryList>

            <AttentionBox icon={ReportProblemRoundedIcon}>
                Revise a lista antes de enviar. Todas as contas contrato informadas serão consideradas no lote de notificação.
            </AttentionBox>

            <AttentionBox icon={AssignmentTurnedInRoundedIcon} title={`${completedFields}/1 preenchido`} tone={completedFields === 1 ? 'ok' : 'navy'}>
                Campos críticos
            </AttentionBox>

            <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                Enviar Notificações
            </SubmitButton>
        </Panel>
    );

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Informar Débitos
            </PageHeader>

            <PageIntro eyebrow='Gestão de energia' title='Notificação de débitos Neoenergia'>
                Cole a lista de contas contrato que receberão a comunicação por WhatsApp sobre débitos junto à distribuidora.
            </PageIntro>

            <TwoColumnLayout as='form' aside={summary} id='formInformarDebitos' method='POST' onSubmit={submitInformarDebitos}>
                <Panel eyebrow='Etapa única' icon={ListAltRoundedIcon} title='Contas contrato do lote'>
                    <FieldRow icon={ReportProblemRoundedIcon}>
                        <TextField
                            label='Conta contratos'
                            id='ccs'
                            required
                            multiline
                            minRows={7}
                            maxRows={14}
                            value={ccs}
                            onChange={(e) => setCCs(e.target.value)}
                            placeholder='Uma CC por linha, ou separadas por vírgula'
                        />
                    </FieldRow>
                </Panel>

                <AttentionBox icon={WhatsAppIcon} title='Envio via WhatsApp' tone='navy'>
                    A lista será enviada para o processo que notifica os clientes sobre pendências junto à Neoenergia.
                </AttentionBox>
            </TwoColumnLayout>
        </Box>
    );
};

export default InformarDebitos;
